/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import {
    object, string, shape, arrayOf, number, func, array, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactHtmlParser from 'react-html-parser';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/Add';
import ExpandLessIcon from '@material-ui/icons/Remove';

import CYOItems from './CYOItems';
import CYOProgressBar from './CYOProgressBar';
import CYORadioItems from './CYORadioItems';
import ConnectedGraphqlFoodAddToCart from '../../GraphqlFoodAddToCart/GraphqlFoodAddToCart';

const styles = ({ palette, breakpoints }) => ({
    expansionPanel: {
        marginBottom: '20px',
        borderRadius: '4px 4px 4px 4px',
        [breakpoints.down(959)]: {
            marginLeft: '10px !important',
        },
    },
    summaryPanel: {
        backgroundColor: palette?.cms?.['cyoHeaderBg'],
        color: palette?.white,
        minHeight: '40px',
        paddingLeft: '10px',
        borderRadius: '4px 4px 4px 4px',
        '& .MuiExpansionPanelSummary-content': {
            margin: '0px',
        },
        '&$expandedPanel': {
            minHeight: '40px',
            borderRadius: '4px 4px 0px 0px',
        },
    },
    expandedPanel: {
        minHeight: '0px',
    },
    expansionPanelTypography: {
        marginLeft: '10px',
    },
    secondaryHeading: {
        textAlign: 'right',
        width: '100%',
        display: 'inline-block',
    },
    expansionPanelDetailsRoot: {
        display: 'block',
    },
    noItemsChosen: {
        fontSize: '12px',
        textAlign: 'center',
        paddingTop: '7px',
    },
    selectedItemTitle: {
        borderBottom: `solid 1px ${palette?.grey7}`,
        margin: '0 0 8px 0',
    },
    selectedItemWrapper: {
        color: palette?.black,
        fontWeight: '400',
        fontSize: '13px',
    },
    removeBtn: {
        fontSize: '10px',
        textAlign: 'left',
        margin: '0',
        display: 'block',
        color: palette?.cms?.cyoRemoveTextColor,
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    selectedItemsRoot: {
        [breakpoints.down(959)]: {
            marginRight: '10px',
        },
    },
});

const DesktopCYOProductItems = ({
    classes,
    cyoData,
    expansionPanelOpen,
    toggleExpansionPanel,
    getTotalCategoryCount,
    selectedBand,
    onRadioButtonChange,
    handleSelectedCyoProduct,
    getOptionSelectList,
    selectedItems,
    getTotalProductSelected,
    cartError,
    progressBarData,
    totalProductSelected,
    maxSelectableForSku,
    selectedItemsNames,
    handleRemoveProduct,
    handleMiniCartModalClick,
    selectedItemId,
    brandId,
    cyoSelectedComponents,
    product,
    isBandItemSelected,
    handleMobileAgeVerification,
    hasWine,
}) => (
    <Grid container spacing={4}>
        <Grid item sm={9} lg={9}>
            {cyoData?.cyoGroup?.map((cyoGroup, index) => (
                <ExpansionPanel key={cyoGroup?.name} className={classes.expansionPanel} expanded={expansionPanelOpen === `panel${index + 1}`} onChange={toggleExpansionPanel(`panel${index + 1}`)}>
                    <ExpansionPanelSummary
                        aria-controls={`panel${index + 1}a-content`}
                        id={`panel${index + 1}`}
                        classes={{
                            root: classes.summaryPanel,
                            expanded: classes.expandedPanel,
                        }}
                    >
                        {(expansionPanelOpen === `panel${index + 1}` ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
                        <Typography className={classes.expansionPanelTypography}>{cyoGroup.name}</Typography>
                        {getTotalCategoryCount(cyoGroup) > 0
                                && (<Typography className={classes.secondaryHeading}>{getTotalCategoryCount(cyoGroup)} Items Total Selected</Typography>)}
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                        classes={{
                            root: classes.expansionPanelDetailsRoot,
                        }}
                    >
                        {
                            cyoGroup.type === 'cyoBands'
                                ? cyoGroup?.components?.map((component) => (
                                    <FormControl key={component.legacyId} component="fieldset">
                                        <RadioGroup aria-label="cyoBands" name="cyoBands" value={selectedBand} onChange={onRadioButtonChange(component, maxSelectableForSku, cyoGroup)}>
                                            <CYORadioItems
                                                component={component}
                                                selectedBand={selectedBand}
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                ))
                                : cyoGroup?.components?.map((component) => (
                                    <div key={component.legacyId}>
                                        <CYOItems
                                            component={component}
                                            handleSelectedCyoProduct={handleSelectedCyoProduct}
                                            getOptionSelectList={getOptionSelectList}
                                            maxComponents={cyoData.maxQuantity || cyoGroup.numberofUnitsRequiredForComponent}
                                            cyoGroup={cyoGroup}
                                            selectedItems={selectedItems}
                                            totalProductSelected={cyoData.maxQuantity ? getTotalProductSelected(cyoData) : getTotalCategoryCount(cyoGroup)}
                                            cartError={cartError}
                                        />
                                    </div>
                                ))
                        }

                    </ExpansionPanelDetails>
                </ExpansionPanel>
            ))}
        </Grid>
        <Grid item sm={3} lg={3}>
            <Card className={classes.selectedItemsRoot}>
                <CardContent>
                    <CYOProgressBar
                        valueBufferBar={progressBarData}
                        totalProductSelected={totalProductSelected}
                        maxComponents={maxSelectableForSku}
                    />
                    <Grid container spacing={2} className={classes.selectedItemWrapper}>
                        {selectedItemsNames.length > 0
                            ? (
                                <>
                                    <Grid container spacing={2} className={classes.selectedItemTitle}>
                                        <Grid item sm={10} lg={10}>Selected Items</Grid>
                                        <Grid item sm={2} lg={2}>Qty</Grid>
                                    </Grid>
                                    {selectedItemsNames.map((selectedData) => (
                                        <React.Fragment key={selectedData?.productId}>
                                            <Grid item sm={10} lg={10}>
                                                {ReactHtmlParser(selectedData?.name)}
                                                <div
                                                    onClick={() => handleRemoveProduct(selectedData?.productId)}
                                                    onKeyDown={() => handleRemoveProduct(selectedData?.productId)}
                                                    role="button"
                                                    tabIndex={-1}
                                                    className={classes.removeBtn}
                                                >
                                                    Remove
                                                </div>
                                            </Grid>
                                            <Grid item sm={2} lg={2}>{selectedData?.value}</Grid>
                                        </React.Fragment>
                                    ))}
                                </>
                            )
                            : (
                                <Grid className={classes.noItemsChosen}>
                                    No items chosen. Please make your selections on the left.
                                </Grid>
                            )}
                    </Grid>
                </CardContent>
            </Card>
            <ConnectedGraphqlFoodAddToCart
                handleMiniCartModalClick={handleMiniCartModalClick}
                selectedItemId={selectedItemId}
                brandId={brandId}
                productType="cyo"
                totalProductSelected={totalProductSelected}
                maxComponents={maxSelectableForSku}
                cyoSelectedComponents={cyoSelectedComponents}
                partNumber={product.partNumber}
                product={product}
                isBandItemSelected={isBandItemSelected()}
                hasWine={hasWine}
                handleMobileAgeVerification={handleMobileAgeVerification}
            />
        </Grid>
    </Grid>
);

DesktopCYOProductItems.propTypes = {
    classes: object.isRequired,
    selectedItemId: string,
    brandId: string.isRequired,
    handleMiniCartModalClick: func.isRequired,
    cyoData: shape({
        maxQuantity: number.isRequired,
        cyoGroup: arrayOf(
            shape({
                name: string.isRequired,
                components: arrayOf(
                    shape({
                        id: string.isRequired,
                        legacyId: string.isRequired,
                        name: string.isRequired,
                        image: shape({
                            name: string.isRequired,
                            path: string.isRequired,
                        }),
                    }),
                ).isRequired,
            }),
        ).isRequired,
    }).isRequired,
    product: object.isRequired,
    cartError: string.isRequired,
    expansionPanelOpen: string.isRequired,
    toggleExpansionPanel: func.isRequired,
    getTotalCategoryCount: func.isRequired,
    selectedBand: string.isRequired,
    onRadioButtonChange: func.isRequired,
    handleSelectedCyoProduct: func.isRequired,
    getOptionSelectList: func.isRequired,
    selectedItems: object.isRequired,
    getTotalProductSelected: func.isRequired,
    progressBarData: number.isRequired,
    totalProductSelected: number.isRequired,
    maxSelectableForSku: number.isRequired,
    selectedItemsNames: array.isRequired,
    handleRemoveProduct: func.isRequired,
    cyoSelectedComponents: array,
    isBandItemSelected: func.isRequired,
    handleMobileAgeVerification: func,
    hasWine: bool,
};

DesktopCYOProductItems.defaultProps = {
    selectedItemId: null,
    cyoSelectedComponents: [],
    handleMobileAgeVerification: () => {},
    hasWine: false,
};

export default withStyles(styles)(DesktopCYOProductItems);
